import { motion } from 'framer-motion';

export function ServiceAreas() {
  const areas = [
    'Arlington', 'Grand Prairie', 'Mansfield', 'Fort Worth',
    'Irving', 'Euless', 'Bedford', 'Hurst',
    'Kennedale', 'Pantego', 'North Arlington', 'Burleson',
    'Crowley', 'Duncanville', 'DeSoto', 'Cedar Hill',
  ];

  return (
    <section id="service-areas" className="py-24 bg-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 right-0 w-80 h-80 bg-teal-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-orange-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-teal-400 text-sm font-semibold tracking-widest uppercase mb-3 block">
            Service Territory
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Serving Arlington &amp;{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-orange-400">
              DFW Metroplex
            </span>
          </h2>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            From our Arlington, TX location we serve businesses across Tarrant and Dallas County.
            Professional signage delivered and installed throughout the metroplex.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="grid grid-cols-2 gap-3 mb-8">
              {areas.map((area, index) => (
                <div
                  key={index}
                  className="flex items-center space-x-2 bg-white/5 border border-white/10 rounded-lg px-4 py-3 hover:border-teal-500/50 transition-colors"
                >
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-2-fill text-teal-400 text-sm"></i>
                  </div>
                  <span className="text-gray-300 text-sm font-medium">{area}</span>
                </div>
              ))}
            </div>

            <div className="bg-white/5 border border-white/10 rounded-2xl p-6">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-teal-500/20 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-truck-line text-teal-400 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-white font-bold mb-1">On-Site Service Available</h4>
                  <p className="text-gray-400 text-sm">
                    We travel to your location for consultations, measurements, and professional
                    installation anywhere in the DFW Metroplex. No extra travel fees within
                    our primary service area.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="rounded-2xl overflow-hidden border border-white/10 h-96">
              <iframe
                title="Signarama Arlington Service Area Map"
                src="https://maps.google.com/maps?q=2400+W+Pioneer+Pkwy+%23118+Arlington+TX+76013&output=embed&z=11"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <div className="flex items-center space-x-2 text-gray-400 text-sm">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-fill text-orange-400"></i>
                </div>
                <span>2400 W Pioneer Pkwy #118, Arlington, TX 76013</span>
              </div>
              <a
                href="https://www.google.com/maps/search/?api=1&query=32.708617,-97.147128&query_place_id=ChIJkRKWLsV8ToYRhAcULCMpvSc"
                target="_blank"
                rel="noopener noreferrer"
                className="text-teal-400 text-sm font-medium hover:text-teal-300 transition-colors cursor-pointer whitespace-nowrap"
              >
                Get Directions →
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
